import * as React from "react";
import type { SVGProps } from "react";
const SvgAvatarAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <rect width={20} height={20} x={2} y={2} fill="#0C21A3" rx={10} />
    <path
      stroke="#23F6E7"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 16v-.375a2.125 2.125 0 0 0-2.125-2.125h-3.75A2.125 2.125 0 0 0 8 15.625V16"
    />
    <circle
      cx={12}
      cy={9.5}
      r={2}
      stroke="#23F6E7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgAvatarAccount;
